import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from './services/interceptor.interceptor';
import { AuthGuard } from './services/auth-guard.guard';
import { Globals } from './services/global';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgOtpInputModule } from 'ng-otp-input';
import { BrowserModule } from '@angular/platform-browser';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MaterialExampleModule } from '../material/material.module';
import { LangTranslationModule } from '../translation/translation.module';
import { VerifyOtpComponent } from './components/verify-otp/verify-otp.component';
import { HeaderComponent } from './components/header/header.component';
import { SuccessComponent } from './components/success/success.component';
import { StoreNavigationComponent } from './components/store-navigation/store-navigation.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { InformationComponent } from './information/information.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { NotificationComponent } from './components/notification/notification.component';
import { NotificationPopupComponent } from './components/notification-popup/notification-popup.component';
import { VerifyMpinComponent } from './components/verify-mpin/verify-mpin.component';


@NgModule({
    declarations: [
        VerifyOtpComponent,
        HeaderComponent,
        SuccessComponent,
        StoreNavigationComponent,
        ConfirmationComponent,
        InformationComponent,
        PageNotFoundComponent,
        NotificationComponent,
        NotificationPopupComponent,
        VerifyMpinComponent
  ],
    imports: [
        CommonModule,
        MaterialExampleModule,
        ReactiveFormsModule,
        FormsModule,
        NgOtpInputModule,
        LangTranslationModule,
        NgxSpinnerModule,
        // NgxIntlTelInputModule,
        
    ],
    exports: [
        CommonModule,
        MaterialExampleModule,
        ReactiveFormsModule,
        FormsModule,
        NgOtpInputModule,
        VerifyOtpComponent,
        HeaderComponent,
        SuccessComponent,
        StoreNavigationComponent,
        InformationComponent,
        PageNotFoundComponent,
        NotificationComponent,
        NotificationPopupComponent,
        VerifyMpinComponent
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true
        },
        AuthGuard,
        // Globals,
    ]
})
export class SharedModule { }
